import { Box, Grid, Typography, makeStyles } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import {
  CadastroPagarmeRecebedorResponse,
  obterCadastroPagarmeRecebedor
} from 'src/api/recebedor-pendencia-bacen'
import Drawer from 'src/components/ui/Drawer'
import { showNotificationErrorAPI } from 'src/core/helpers/notification'

const useStyles = makeStyles(theme => ({
  secao: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2, 3),
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8,
    backgroundColor: '#fff'
  },
  tituloSecao: {
    fontSize: 20,
    fontWeight: 500,
    color: '#455890',
    marginBottom: theme.spacing(1)
  },
  rotulo: {
    color: theme.palette.text.secondary,
    fontSize: 12
  },
  valor: {
    fontWeight: 500,
    wordBreak: 'break-word',
    marginBottom: theme.spacing(1.5)
  }
}))

type Props = {
  pendenciaId: string | null
  open: boolean
  onClose: () => void
}

function ItemLeitura({ rotulo, valor }: { rotulo: string; valor: string }) {
  const classes = useStyles()
  return (
    <Box component="div">
      <Typography className={classes.rotulo} component="dt">
        {rotulo}
      </Typography>
      <Typography className={classes.valor} component="dd">
        {valor || '—'}
      </Typography>
    </Box>
  )
}

export default function DrawerCadastroPagarme({
  pendenciaId,
  open,
  onClose
}: Props) {
  const classes = useStyles()
  const [cadastro, setCadastro] = useState<CadastroPagarmeRecebedorResponse | null>(
    null
  )
  const [carregando, setCarregando] = useState(false)

  useEffect(() => {
    if (!open || !pendenciaId) {
      return
    }

    let ativo = true
    setCadastro(null)
    setCarregando(true)

    obterCadastroPagarmeRecebedor(pendenciaId)
      .then(resposta => {
        if (!ativo) return
        setCadastro(resposta.data)
      })
      .catch(erro => {
        if (!ativo) return
        showNotificationErrorAPI(erro)
        onClose()
      })
      .finally(() => {
        if (ativo) setCarregando(false)
      })

    return () => {
      ativo = false
    }
  }, [open, pendenciaId])

  return (
    <Drawer
      open={open}
      loading={carregando}
      anchor="right"
      titulo="Informação completa na Pagar.me"
      handleOnClose={onClose}
    >
      {cadastro && (
        <Box component="article">
          {cadastro.secoes.map(secao => (
            <Box
              key={secao.titulo}
              className={classes.secao}
              component="section"
              aria-label={secao.titulo}
            >
              <Typography className={classes.tituloSecao} component="h3">
                {secao.titulo}
              </Typography>
              <Grid container spacing={2} component="dl">
                {secao.itens.map(item => (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    key={`${secao.titulo}-${item.rotulo}`}
                  >
                    <ItemLeitura rotulo={item.rotulo} valor={item.valor} />
                  </Grid>
                ))}
              </Grid>
            </Box>
          ))}
        </Box>
      )}
    </Drawer>
  )
}
